/* eslint-disable */
import createIcon from '../createIcon';

const IconSendOut = createIcon({
  name: 'icon-send-out',
  content: '<title>ic_发送</title><defs><rect id="icon-send-out-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1423.000000, -6356.000000)"><g transform="translate(498.000000, 6169.000000)"><g transform="translate(111.000000, 187.000000)"><g transform="translate(814.000000, 0.000000)"><mask id="icon-send-out-b" fill="currentColor"><use xlink:href="#icon-send-out-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-send-out-a"/><path d="M15.3679038,0.875065072 L13.4099483,14.3798977 L8.43973427,11.990939 L7.01401059,14.864577 L4.66937895,10.0286764 L1.07030946,8.02386227 L15.3679038,0.875065072 Z" stroke="currentColor" mask="url(#icon-send-out-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconSendOut;
